import React from "react";

// Mui Styles
import { StyledPaper } from "../styles/mui/globalStyles";

// Mui
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import ExchangeInvoiceDataRow from "../components/exchangeInvoiceDataRow";
import Layout from "../components/layout";
import Title from "../components/title";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import { getExchangeInvoice } from "../fetch/fetchStock";

const ExchangeInvoiceByIdPage = (props) => {
  const { open, setOpen } = props;

  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  // const [dropDownId, setDropDownId] = React.useState(null);
  const [rowsData, setRowsData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  // Fetch
  const fetchAll = async () => {
    await getExchangeInvoice(id, undefined, undefined, undefined).then(
      (data) => {
        if (data && data.results) setRowsData(data.data);
      }
    );
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={25}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`換貨清單/詳細`} history={() => navigate(-1)} />
      <StyledPaper page={"yes"}>
        <Grid container spacing={2}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>員工名稱</TableCell>
                  {/* <TableCell>客人名稱</TableCell> */}
                  <TableCell>換貨地點</TableCell>
                  <TableCell>換貨原因</TableCell>
                  <TableCell>換貨貨品</TableCell>
                  <TableCell align="center">進/出</TableCell>
                  <TableCell align="center">數量</TableCell>
                  <TableCell align="center">換貨時間</TableCell>
                  {/* <TableCell align="center">狀態</TableCell> */}
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              {rowsData.length > 0 ? (
                rowsData.map((data, index) => (
                  <ExchangeInvoiceDataRow
                    data={data}
                    key={index}
                    // handleChecked={handleChecked}
                  />
                ))
              ) : rowsData.length <= 0 && isLoading === false ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      沒有資料
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Grid>
      </StyledPaper>
    </Layout>
  );
};

export default ExchangeInvoiceByIdPage;
